import { CommonModule } from '@angular/common';
import { Component, inject, type OnInit } from '@angular/core';
import { AppNotification, CustomNotificationService } from 'src/app/services/customNotificationService.service';
import { NotificationPushService } from 'src/app/services/notificationPush.service';

@Component({
  selector: 'app-custom-toast',
  imports: [CommonModule],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
})
export class CustomToastComponent implements OnInit {
  ngOnInit(): void { }

  toastService = inject(CustomNotificationService);
  pushService = inject(NotificationPushService);

  onNotificationClick(msg: AppNotification) {
    console.log("🚀 Notificación clickeada:", msg);
  }

  close(event: Event, id: string) {
    event.stopPropagation(); // Evita que se dispare el onNotificationClick
    this.toastService.remove(id);
  }
}
